<div class="login">
    <div class="login__wrapper">
        <h2 class="login__title" [translate]="'auth.registration.confirmTitle'"></h2>
        <div class="login__message"
             [translate]="'auth.registration.confirmedEmail'"></div>

        <button (click)="moveLogin()" class="login__form-sign-btn" [translate]="'btns.continue'"></button>
    </div>
</div>
